<template>
  <g>
    <path
      d="M10.23 15.8302C10.62 16.2202 11.25 16.2202 11.64 15.8302L15.88 11.5902C16.27 11.2002 16.27 10.5702 15.88 10.1702C15.49 9.78019 14.86 9.78019 14.47 10.1702L10.93 13.7002L9.51997 12.2902C9.12997 11.9002 8.49997 11.9002 8.09997 12.2902C7.69997 12.6802 7.70997 13.3102 8.09997 13.7002L10.23 15.8302Z"
    />
    <path
      d="M19 4.00024H5C3.89 4.00024 3 4.90024 3 6.00024V18.0002C3 19.1002 3.89 20.0002 5 20.0002H19C20.1 20.0002 21 19.1002 21 18.0002V6.00024C21 4.90024 20.11 4.00024 19 4.00024ZM19 17.0002C19 17.5502 18.55 18.0002 18 18.0002H6C5.45 18.0002 5 17.5502 5 17.0002V8.00024H19V17.0002Z"
    />
  </g>
</template>
